<style>
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center"
    >
      Data Anggota
      <CButton
        color="danger"
        style="float:right;margin-right:10px"
        class="btn-md ml-auto"
      >Ekspor PDF</CButton>
      <CDropdown
        toggler-text="Ekspor Excel"
        color="warning"
        class="mr-2 d-inline-block text-white float-right"
      >
        <CDropdownItem>Ekspor Semua</CDropdownItem>
        <CDropdownItem>Ekspor Beberapa Data</CDropdownItem>
      </CDropdown>
      <CButton
        color="success"
        style="float:right;margin-right:10px"
        class="btn-md"
        @click="createData()"
      >Tambah</CButton>
    </CCardHeader>
    <!-- Tabs -->
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/keanggotaan/data-anggota"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          style="background-color: #214073 !important;"
          id="home-tab"
          data-toggle="tab"
          href="#data-anggota"
          role="tab"
          aria-controls="data-anggota"
          aria-selected="true"
        >Data Anggota</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/keanggotaan/calon-anggota"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          style="background-color: #486ba7;"
          id="home-tab"
          data-toggle="tab"
          href="#data-anggota"
          role="tab"
          aria-controls="data-anggota"
          aria-selected="true"
        >Calon Anggota</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/keanggotaan/data-anggota/statistik"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          id="statistik-tab"
          data-toggle="tab"
          href="#statistik"
          role="tab"
          aria-controls="statistik"
          aria-selected="false"
        >Statistik</router-link>
      </li>
    </ul>
    <!-- Data BPK -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <CSelect
              label="Data Perhalaman"
              class="float-left"
              @change="changePageSize"
              :options="[10, 25, 100, 'Semua Data']"
            />
          </div>
        </div>
        <div class="col-sm-12 col-xl-3">
          <div class="form-group">
            <label for>Kategori Anggota</label>
            <select
              class="form-control"
              name
              id
              v-model="formData.namaKategori"
              @change="filterByKategori"
            >
              <option value="default" selected>Semua Data</option>
              <option
                v-for="(val, key) in dataKategori"
                :key="key"
                :value="val.namaKategori"
              >{{ val.namaKategori }}</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              name
              id
              class="form-control"
              placeholder="Cari Data ..."
              @keyup="cariData"
              v-model="search"
            />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{ index+1 }}</td>
            </template>
            <template #no_anggota="{item}">
              <td
                class="py-2 text-left font-weight-bold"
              >{{item.no_anggota ? item.no_anggota : "-"}}</td>
            </template>
            <template #nama_lengkap="{item, index}">
              <td
                class="py-2 text-left text-info"
                style="cursor: pointer"
                @click="detailUser(item, index)"
              >{{item.nama_lengkap ? item.nama_lengkap : "-"}}</td>
            </template>
            <template #tangga_jatuh_tempo="{item}">
              <td
                class="py-2 text-center"
              >{{item.tangga_jatuh_tempo ? item.tangga_jatuh_tempo : "-"}}</td>
            </template>
            <template #no_handphone="{item}">
              <td class="py-2 text-center">{{item.no_handphone ? item.no_handphone : "-"}}</td>
            </template>
            <template #no_telephone="{item}">
              <td class="py-2 text-center">{{item.no_telephone ? item.no_telephone : "-"}}</td>
            </template>
            <template #tanggal_daftar="{item}">
              <td
                class="py-2 text-center"
              >{{item.tanggal_daftar ? formatDate(item.tanggal_daftar) : "-"}}</td>
            </template>
            <template #tanggal_update="{item}">
              <td
                class="py-2 text-center"
              >{{item.tanggal_update ? formatDate(item.tanggal_update) : "-"}}</td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center">
                <!-- <router-link :to="{ name: 'Data Anggota', params: { id_user: item.id_user }}"  title="Detail"> -->
                <router-link :to="'/keanggotaan/data-anggota/data-diri/'+item.id_user">
                  <CButton color="warning" class="btn-sm text-white" square>
                    <font-awesome-icon icon="user" />
                  </CButton>
                </router-link>&nbsp;&nbsp;
                <CButton color="info" class="btn-sm mx-1" square @click="updateData(item, index)">
                  <font-awesome-icon icon="key" />
                </CButton>&nbsp;&nbsp;
                <CButton color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <div class="modal-body">
              <form>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="nama" class="font-weight-bold">Nama Lengkap</label>
                    <input
                      type="nama"
                      class="form-control"
                      id="nama"
                      placeholder="Masukkan Nama Lengkap"
                      v-model="formData.nama"
                    />
                  </div>
                  <div class="form-group col-md-12">
                    <label for="email" class="font-weight-bold">Email</label>
                    <input
                      type="email"
                      class="form-control"
                      id="email"
                      placeholder="Masukkan Email"
                      v-model="formData.email"
                    />
                  </div>
                  <div class="form-group col-md-12">
                    <label for="no_telp" class="font-weight-bold">No. Telephone</label>
                    <input
                      type="no_telp"
                      class="form-control"
                      id="no_telp"
                      placeholder="Masukkan No. Telephone"
                      v-model="formData.noTelephone"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label for="pass" class="font-weight-bold">Password</label>
                  <input
                    type="password"
                    class="form-control"
                    id="pass"
                    placeholder="Masukkan Password"
                    v-model="formData.password"
                  />
                </div>
              </form>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{title}}</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->

      <!-- Modal Detail User -->
      <CModal
        title="Modal title"
        :show.sync="modalDetail"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CRow>
          <div class="modal-body row my-n3">
            <div class="col-5">
              <p class="font-weight-bold">Nama Anggota</p>
              <p class="font-weight-bold">Kategori Anggota</p>
              <p class="font-weight-bold">No. Handphone</p>
              <p class="font-weight-bold">No. Telepon</p>
              <p class="font-weight-bold">Email</p>
            </div>
            <div class="col-7">
              <p>: {{ formData.nama_lengkap ? formData.nama_lengkap : ' - ' }}</p>
              <p>: {{ formData.nama_kategori ? formData.nama_kategori : ' - ' }}</p>
              <p>: {{ formData.no_handphone ? formData.no_handphone : ' - ' }}</p>
              <p>: {{ formData.no_telephone ? formData.no_telephone : ' - ' }}</p>
              <p>: {{ formData.email ? formData.email : ' - ' }}</p>
            </div>
          </div>
        </CRow>
        <template #header>
          <h6 class="modal-title h5 font-weight-bold">Detail Anggota</h6>
        </template>
        <template #footer>
          <CButton @click="modalDetail = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data BPK -->
  </CCard>
</template>
<script>
import DataKeanggotaanService from "../../../services/keanggotaan/data-anggota.service";
import KategoriAnggotaService from "../../../services/keanggotaan/kategori-anggota.service";

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    key: "no_anggota",
    label: "No. Regis IAPI",
    _style: "font-weight: bold !important",
    sorter: true,
    filter: false
  },
  {
    key: "nama_lengkap",
    label: "Nama Anggota",
    sorter: true,
    filter: false
  },
  {
    key: "tanggal_daftar",
    label: "Tanggal Terdaftar",
    sorter: true,
    filter: false
  },
  {
    key: "tangga_jatuh_tempo",
    label: "Tanggal Jatuh Tempo",
    sorter: true,
    filter: false
  },
  {
    key: "tanggal_update",
    label: "Tanggal Update",
    sorter: true,
    filter: false
  },
  {
    key: "aksi",
    _style: "width:10%;",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Master DataKeanggotaan",
  data() {
    return {
      search: "",
      pageSize: "",
      items: [],
      actionPost: "",
      namaKategori: [],
      dataKategori: [],
      formData: {
        namaKategori: "",
        nama_kategori: "",
        nama_lengkap: "",
        noTelephone: "",
        no_telelphon: "",
        no_handphone: "",
        email: "",
        nama: "",
        noTelephone: "",
        password: "",
        id_user: ""
      },
      pagination: {
        totalPages: 0
      },
      fields,
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      modalDetail: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  mounted() {
    this.getData("0", this.pageSize, "default");
    // comment console console.log("ini data calon anggota");
    this.getKategori();
  },
  watch: {
    currentPage: function(val) {
      var page = val - 1;
      this.indexed = page * 10;
      this.getData(val - 1, this.pageSize, this.search);
    }
  },

  methods: {
    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },
    cariData() {
      this.getData("0", this.pageSize, this.search);
    },
    pageChange() {
      this.getData(currentPage, this.pageSize, this.search);
    },
    filterByKategori() {
      var value = this.formData.namaKategori;
      DataKeanggotaanService.getCalonAnggota(
        this.currentPage,
        this.pageSize,        
        value
      )
        .then(response => {
          this.items = response.data.data.content;

          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    formatDate(tanggal_daftar) {
      var tanggalTerdaftar = tanggal_daftar.split("-"); // ex input "2010-01-18"
      var tangarTerdaftarUpdate =
        tanggalTerdaftar[0] +
        "-" +
        tanggalTerdaftar[1] +
        "-" +
        tanggalTerdaftar[2].substr(0, 2);
      return tangarTerdaftarUpdate;
    },
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertErrorUser() {
      this.$swal.fire({
        title: "Peringatan!",
        text:
          "Data Sedang Digunakan Di Modul Lain Sehingga Tidak Dapat Dihapus",
        icon: "errorr",
        showCancelButton: true
      });
    },
    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },
    deleteData(item, index) {
      var vm = this;
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            DataKeanggotaanService.deleteDataAnggota(this.formData)
              .then(response => {
                // comment console console.log(response);
                vm.alertSuccess();
                this.getData("0", this.pageSize, this.search);
              })
              .catch(error => {
                vm.alertErrorUser();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            vm.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var vm = this;
      DataKeanggotaanService.getCalonAnggota(currentPage, pageSize, filter)
        .then(response => {
          loader.hide();
          vm.items = response.data.data.content;
          // comment console console.log(response.data);

          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPage = response.data.data.pageable.pageNumber;
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },
    getKategori() {
      KategoriAnggotaService.getAllKategoriAnggota()
        .then(response => {
          // comment console console.log(response.data.data.content);
          this.dataKategori = response.data.data.content;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    createData() {
      this.myModal = true;
      this.formData = {};
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.formData.nama = item.nama_lengkap;
      this.formData.noTelephone = item.no_handphone;
      this.actionPost = "update";
      this.title = "Edit";
    },

    detailUser(item, index) {
      this.modalDetail = true;
      this.formData = item;
    },

    postData() {
      if (this.actionPost == "insert") {
        this.insertData(this.formData);
      } else if (this.actionPost == "update") {
        this.putData();
      }
    },

    insertData(formData) {
      // comment console console.log(formData);
      // comment console console.log("post");
      var vm = this;
      DataKeanggotaanService.postDataAnggota(formData)
        .then(response => {
          vm.myModal = false;
          vm.alertSuccess();
          this.getData("0", this.pageSize, this.search);
        })
        .catch(error => {
          // comment console console.log(error);
          vm.alertError();
        });
    },

    putData() {
      // comment console console.log("put");
      // comment console console.log(this.formData);
      var vm = this;
      DataKeanggotaanService.putDataAnggotaUrl(this.formData)
        .then(response => {
          vm.myModal = false;

          vm.alertSuccess();

          this.getData("0", this.pageSize, 'default');
        })
        .catch(error => {
          // comment console console.log(error);

          vm.alertError();
        });
    }
  }
};
</script>